/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/
import React from 'react';
import { useConfig } from '../contexts/config';
import { Dropdown } from '@carbon/react';
import { get } from 'lodash';

function ExplorerHeader() {
  const config = useConfig();
  const title = config.options.headerTitle;
  const switchVersion = (e) => {
    window.location.assign(e.selectedItem.url);
  };
  const versions = get(config, 'options.versions');
  const versionsArray = [];
  if (versions && Object.values(versions).length > 0) {
    Object.entries(versions).forEach(([key, value]) => {
      versionsArray.push({ text: key, url: value });
    });
  }

  return (
    <nav className={'apic--explorer-header'} data-testid={'explorer-header'}>
      <div className={'apic--explorer-header-brand-container'}>
        <div className={'apic--brand-text'}>
          IBM <span className={'bold'}>API</span> Connect
        </div>
        {versions && Object.values(versions).length > 0 && (
          <Dropdown
            className={'apic--brand-text dropdown'}
            label={title}
            onChange={switchVersion}
            data-testid={'version-picker'}
            id={'version-picker'}
            itemToString={(item) => (item ? item.text : '')}
            items={versionsArray}
          />
        )}
        {(!versions || Object.values(versions).length === 0) && <div className={'apic--brand-text'}>{title}</div>}
      </div>
    </nav>
  );
}

export default ExplorerHeader;
